import {
  convertCirclesToZero,
  NYFillWidthNumberToHalfWidthNumber,
} from "@/utils/utils";

const KANJI_DIGIT_MAP: Record<string, number> = {
  〇: 0,
  零: 0,
  一: 1,
  二: 2,
  三: 3,
  四: 4,
  五: 5,
  六: 6,
  七: 7,
  八: 8,
  九: 9,
};

const KANJI_MULTIPLIER_MAP: Record<string, number> = {
  十: 10,
  百: 100,
  千: 1000,
};

const KANJI_NUMBER_PATTERN = /[〇零一二三四五六七八九十百千万]+/g;

const normalizeSpaces = (value: string): string => {
  return value.replace(/\s|\u3000/g, "");
};

const replaceKanjiNumbers = (value: string): string => {
  return value.replace(KANJI_NUMBER_PATTERN, (match) => {
    const converted = convertKanjiNumberSegment(match);
    return converted ?? match;
  });
};

const convertKanjiNumberSegment = (segment: string): string | null => {
  let total = 0;
  let current = 0;
  let lastWasMultiplier = false;
  let hasConvertibleChar = false;

  for (const char of segment) {
    if (char in KANJI_DIGIT_MAP) {
      hasConvertibleChar = true;
      const digit = KANJI_DIGIT_MAP[char];
      if (lastWasMultiplier) {
        current = digit;
      } else {
        current = current * 10 + digit;
      }
      lastWasMultiplier = false;
      continue;
    }

    if (char in KANJI_MULTIPLIER_MAP) {
      hasConvertibleChar = true;
      const multiplier = KANJI_MULTIPLIER_MAP[char];
      const base = current === 0 ? 1 : current;
      total += base * multiplier;
      current = 0;
      lastWasMultiplier = true;
      continue;
    }

    if (char === "万") {
      hasConvertibleChar = true;
      const chunk = total + current;
      const applied = (chunk === 0 ? 1 : chunk) * 10000;
      total = applied;
      current = 0;
      lastWasMultiplier = true;
      continue;
    }

    return null;
  }

  if (!hasConvertibleChar) return null;

  const finalValue = total + current;
  return finalValue.toString();
};

export const normalizeTextForSearch = (
  value: string | null | undefined
): string => {
  if (value == null) return "";
  const trimmed = value.trim();
  if (trimmed === "") return "";
  const withoutSpaces = normalizeSpaces(trimmed);
  const zeroNormalized = convertCirclesToZero(withoutSpaces);
  const kanjiConverted = replaceKanjiNumbers(zeroNormalized);
  const halfWidth = NYFillWidthNumberToHalfWidthNumber(kanjiConverted);
  return halfWidth.toLowerCase();
};
